// src/hooks/useAnnouncements.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for announcements management
 * Connects to AppContext for centralized state management
 */
export const useAnnouncements = () => {
    const { state, actions } = useAppContext();

    return {
        // State
        announcements: state.announcements || [],
        loading: state.loading,
        error: state.error,
        
        // Actions
        fetchAnnouncements: actions.fetchAnnouncements,
        createAnnouncement: actions.createAnnouncement,
        updateAnnouncement: actions.updateAnnouncement,
        deleteAnnouncement: actions.deleteAnnouncement,

        // Utility functions
        getAnnouncementById: (announcementId) => {
            return state.announcements?.find(announcement => announcement.id === announcementId);
        },

        getActiveAnnouncements: () => {
            return state.announcements?.filter(announcement => announcement.active) || [];
        },

        getAnnouncementCount: () => state.announcements?.length || 0
    };
};

export default useAnnouncements;
